import { connect, MapStateToProps } from 'react-redux';
import { Props } from './SearchPage';
import { AppState } from '../../../../types/store';
import {
  getOrderSubnavigation,
  getSearchType,
} from '../../../../selectors/page';
import { getInitialOffset } from '../../../../selectors/stream';

export type StateProps = Pick<
  Props,
  'hasOrderSubnav' | 'initialOffset' | 'searchType'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  hasOrderSubnav: !!getOrderSubnavigation(state),
  initialOffset: getInitialOffset(state),
  searchType: getSearchType(state),
});

export default connect(mapStateToProps);
